import React from 'react';
import { FlagIcon } from './FlagIcon';

export const FlagES = props => (
    <FlagIcon {...props} viewBox="0 0 512 512">
        <rect width="512" height="512" fill="#C60B1E" />
        <rect width="512" height="170.67" y="170.67" fill="#FFC400" />
    </FlagIcon>
);
